import type { PropsWithChildren } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { SKIP_TEXT_WIDTH } from './constants';

interface ScalesSkipsProps {
  x: number;
  height: number;
  textColor: string;
  isSkipsVisible: boolean;
}

export const ScalesSkips = ({
  x,
  height,
  isSkipsVisible,
  textColor,
  children,
}: PropsWithChildren<ScalesSkipsProps>) => {
  const { opacity } = useSpring({
    opacity: isSkipsVisible ? 1 : 0,
  });

  if (!isSkipsVisible) {
    return null;
  }

  return (
    <animated.text
      x={x}
      height={height}
      width={SKIP_TEXT_WIDTH}
      dx="-1%"
      fontSize={`${height * 0.3}px`}
      dy={height / 2}
      fill={textColor}
      textAnchor="end"
      opacity={opacity}
    >
      {children}
    </animated.text>
  );
};
